import { render, staticRenderFns } from "./CampoFecha.vue?vue&type=template&id=dc8e7654&"
import script from "./CampoFecha.vue?vue&type=script&lang=js&"
export * from "./CampoFecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports